import { ClerkProvider } from "@clerk/react";
import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

const clerkKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (sentryDsn) Sentry.init({ dsn: sentryDsn, tracesSampleRate: 0.05, sendDefaultPii: false, beforeSend(event) { delete event.user; if (event.request) { delete event.request.data; delete event.request.cookies; delete event.request.headers; } return event; } });
if (!clerkKey) throw new Error("VITE_CLERK_PUBLISHABLE_KEY is required");

createRoot(document.getElementById("root")!).render(
  <StrictMode><ClerkProvider publishableKey={clerkKey}><App /></ClerkProvider></StrictMode>,
);
